<template>
<v-toolbar dark color="#A6C307">

    <v-toolbar-title>{{ title }}
        <div class="subheading text-sm-left">{{ description }}</div>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-btn icon :disabled="pending" @click="closeIframe">
        <v-icon>close</v-icon>
    </v-btn>

</v-toolbar>
</template>

<script>
// import { EventBus } from './EventBus.js';

export default {
    name: 'NavBar',
    props: {
        pending: { type: Boolean, default: false },
        description: { type: String, default: ''},
        title: { type: String, default: ''},
    },

    data() {
        return {
            step_description: ''
        }
    },
    methods: {
        closeIframe() {
            this.$emit('close');
        },
    }
}
</script>
<style>
/* TODO: change px for rem */
.subheading{
    font-size:12px !important;
}
</style>
